var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("page-header", {
        attrs: { page: _vm.page },
        scopedSlots: _vm._u([
          {
            key: "custom_actions",
            fn: function() {
              return [
                _vm.menuAdvanceModeEnabled
                  ? _c("menu-search", {
                      model: {
                        value: _vm.searchQuery,
                        callback: function($$v) {
                          _vm.searchQuery = $$v
                        },
                        expression: "searchQuery"
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("menu-options", {
        attrs: {
          "advance-mode": _vm.menuAdvanceModeEnabled,
          "menu-title": _vm.navTitle,
          search: _vm.searchQuery
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }